import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Admin API endpoints
export const adminApi = {
  // Auth
  login: (credentials) => api.post('/api/admin/auth/login', credentials),
  getMe: () => api.get('/api/admin/auth/me'),

  // Dashboard
  getStats: () => api.get('/api/admin/stats'),

  // Tenants
  getTenants: (page = 1, limit = 10, search = '') =>
    api.get('/api/admin/tenants', { params: { page, limit, search } }),
  getTenant: (id) => api.get(`/api/admin/tenants/${id}`),
  createTenant: (data) => api.post('/api/admin/tenants', data),
  updateTenant: (id, data) => api.put(`/api/admin/tenants/${id}`, data),
  deleteTenant: (id) => api.delete(`/api/admin/tenants/${id}`),

  // Tenant Settings
  getTenantSettings: (id) => api.get(`/api/admin/tenants/${id}/settings`),
  updateTenantSettings: (id, settings) => api.put(`/api/admin/tenants/${id}/settings`, { settings }),
  resetTenantSettings: (id) => api.post(`/api/admin/tenants/${id}/settings/reset`),
  uploadTenantLogo: (id, file) => {
    const formData = new FormData()
    formData.append('logo', file)
    return api.post(`/api/admin/tenants/${id}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  deleteTenantLogo: (id) => api.delete(`/api/admin/tenants/${id}/logo`),
  uploadTenantFavicon: (id, file) => {
    const formData = new FormData()
    formData.append('favicon', file)
    return api.post(`/api/admin/tenants/${id}/favicon`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  deleteTenantFavicon: (id) => api.delete(`/api/admin/tenants/${id}/favicon`),

  // Features
  getFeatures: () => api.get('/api/admin/features'),
  getFeature: (id) => api.get(`/api/admin/features/${id}`),
  createFeature: (data) => api.post('/api/admin/features', data),
  updateFeature: (id, data) => api.put(`/api/admin/features/${id}`, data),
  deleteFeature: (id) => api.delete(`/api/admin/features/${id}`),

  // Tenant Features
  getTenantFeatures: (tenantId) => api.get(`/api/admin/tenants/${tenantId}/features`),
  updateTenantFeature: (tenantId, featureId, data) =>
    api.put(`/api/admin/tenants/${tenantId}/features/${featureId}`, data),
  toggleTenantFeature: (tenantId, featureId, isEnabled) =>
    api.post(`/api/admin/tenants/${tenantId}/features/${featureId}/toggle`, { isEnabled }),
  getAvailableFeatures: (tenantId) => api.get(`/api/admin/tenants/${tenantId}/features/available`),
  assignFeatures: (tenantId, featureIds, isEnabled = true) =>
    api.post(`/api/admin/tenants/${tenantId}/features/assign`, { featureIds, isEnabled }),

  // Bulk Operations
  bulkAssignFeatures: (tenantIds, featureIds, isEnabled = true) =>
    api.post('/api/admin/tenants/bulk/features/assign', { tenantIds, featureIds, isEnabled }),
  bulkUnassignFeatures: (tenantIds, featureIds) =>
    api.post('/api/admin/tenants/bulk/features/unassign', { tenantIds, featureIds }),
  bulkUpdateTenants: (tenantIds, updates) =>
    api.post('/api/admin/tenants/bulk/update', { tenantIds, updates }),

  // Admin Users
  getAdminUsers: () => api.get('/api/admin/users'),
  createAdminUser: (data) => api.post('/api/admin/users', data),
  updateAdminUser: (id, data) => api.put(`/api/admin/users/${id}`, data),
  deleteAdminUser: (id) => api.delete(`/api/admin/users/${id}`),
} 